module.exports = __webpack_public_path__ + "img/Number=95.aedfcdcd.png";